// Copyright 2020 Drivetrain Hub LLC
// GraphQL request helpers for tool data.

const TYPENAME = {
  HOB: 'Hob',
  RACK_CUTTER: 'RackCutter',
  PINION_CUTTER: 'PinionCutter',
  BASIC_RACK: 'BasicRack',
};

const TYPENAME_GEOM = {
  HOB: 'HobGeom',
  RACK_CUTTER: 'RackCutterGeom',
  PINION_CUTTER: 'PinionCutterGeom',
  BASIC_RACK: 'BasicRackGeom',
};

const INPUT_TYPE = {
  CREATE_HOB: 'HobInput',
  UPDATE_HOB: 'UpdateHobInput',
  CREATE_RACK_CUTTER: 'RackCutterInput',
  UPDATE_RACK_CUTTER: 'UpdateRackCutterInput',
  CREATE_PINION_CUTTER: 'PinionCutterInput',
  UPDATE_PINION_CUTTER: 'UpdatePinionCutterInput',
  CREATE_BASIC_RACK: 'BasicRackInput',
  UPDATE_BASIC_RACK: 'UpdateBasicRackInput',
};

// region BASIC RACK

const BasicRackGeom = `
  addendumCoefficient
  dedendumCoefficient
  moduleNormal
  pressureAngle
  rootHeightLimit
  rootRadiusCoefficient
  rootRadiusMax
  undercutAngle
  undercutSize`;

const BasicRack = `
  geom {
    ${BasicRackGeom}
  }`;

// endregion

// region HOB

const HobGeom = `
  addendumCoefficient
  dedendumCoefficient
  moduleNormal
  pressureAngleNormal
  protuberanceAngle
  protuberanceSize
  tipRadiusCoefficient
  tipRadiusMax`;

const Hob = `
  geom {
    ${HobGeom}
  }`;

// hob specific geom
// activeLength
// numberOfFlutes
// numberOfThreads
// pitchDiameter
// threadHelixHand

// endregion

// region RACK CUTTER

const RackCutterGeom = `
  addendumCoefficient
  dedendumCoefficient
  moduleNormal
  pressureAngleNormal
  protuberanceAngle
  protuberanceSize
  tipRadiusCoefficient
  tipRadiusMax`;

const RackCutter = `
  geom {
    ${RackCutterGeom}
  }`;

// rack cutter specific geom
// ?

// endregion

// region PINION CUTTER

const PinionCutterGeom = `
  addendumCoefficient
  dedendumCoefficient
  helixAngle
  moduleNormal
  numberOfTeeth
  pressureAngleNormal
  profileShiftCoefficient
  protuberanceSize
  tipRadiusCoefficient
  tipRadiusMax`;

const PinionCutter = `
  geom {
    ${PinionCutterGeom}
  }`;

const PinionCutterGeomInput = {
  addendumCoefficient: null,
  dedendumCoefficient: null,
  helixAngle: null,
  moduleNormal: null,
  numberOfTeeth: null,
  pressureAngleNormal: null,
  profileShiftCoefficient: null,
  protuberanceSize: null,
  tipRadiusCoefficient: null,
  tipRadiusMax: null,
};

// endregion

export default {
  TYPENAME: TYPENAME,
  TYPENAME_GEOM: TYPENAME_GEOM,
  INPUT_TYPE: INPUT_TYPE,
  BasicRack: BasicRack,
  Hob: Hob,
  RackCutter: RackCutter,
  PinionCutter: PinionCutter,
  PinionCutterGeomInput: PinionCutterGeomInput
}
